<template>
  <div class="border">
    <div class="cocktail">
      <img style="height: 150px;" src="/api/static/icons/cocktail (20231105111207).png">
      <!-- <img style="height: 150px;" src="/cocktail (20231105111207).png"> -->
      <div>
        <div class="name">{{ order.cocktail.name }}
          <div class="alc" v-if="order.cocktail.alcohols">Alc</div>
        </div>
        <div>заказчик: {{ order.username }}</div>
        <div :class="{
          'color_gray': order.status == 'ordering', 'color_cook': order.status == 'cook',
          'color_ready': order.status == 'ready', 'color_history': order.status == 'history'
        }">статус: {{ order.status }}</div>
        <div style="margin-top: 15px;">
          <div class="ingr" v-for="ingr in order.cocktail.ingredients">{{ ingr }}</div>
        </div>
      </div>
      <button class="btn_close" @click="close()">
        &times;
      </button>
    </div>
    <div style="margin-top: 15px;">
      <button class="btn_barman btn_del_order"
        :class="{'del_ready': delAlredy}"
        @click="order_del_cocktail()"
      >del</button>
      <button class="btn_barman" style="color: gray;" @click="change_order_status('ordering')">ordering</button>
      <button class="btn_barman" style="color: var(--bar-color-main);" @click="change_order_status('cook')">cook</button>
      <button class="btn_barman" style="color: #00aa00;" @click="change_order_status('ready')">ready</button>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true, // обязательно
    }
  },
  data() {
    return {
      delAlredy: false,
    }
  },
  methods: {
    redirect() {
      if (this.isRedirect) {
        this.$router.push(`/bar/cocktail/${this.cocktail.id}`)
      }
    },
    async change_order_status(status) {
      let res = await fetch("/api/barman/order_status", {
        method: "POST",
        headers: {"content-type": "application/json"},
        body: JSON.stringify({
          order_id: this.order.order_id,
          status: status
        })
      })
      if (res.status === 200) {
        let answer = await res.json();
        this.order.status = answer.order_status;
      }
    },
    async order_del_cocktail() {
      if (this.delAlredy === false) {
        this.delAlredy = true;
      } else if (this.delAlredy === true) {
        let res = await fetch("/api/barman/order_del", {
          method: "POST",
          headers: {"content-type": "application/json"},
          body: JSON.stringify({order_id: this.order.order_id})
        })
        if (res.status === 200) {
          let answer = await res.json();
          this.close();
        }
      }
    },
    close() {
      this.$emit('hideEvent');
    }
  }
}
</script>

<style scoped>
.border {
  /* margin-top: 15px; */
  padding: 5px;
  border: 6px solid var(--bar-color-main);
  border-radius: 15px;
}
.cocktail {
  display: flex;
  /* color: black; */
}
.name {
  display: flex;
  color: black;
  font-size: 40px;
  padding: 25px;
  /* align-self: center; */
  /* align-content: center; */
  align-items: center;
}
.alc {
  margin-left: 25px;
  color: HotPink;
  font-size: 40px;
}
.ingr {
  color: black;
  font-size: 30px;
}

.color_gray {
  color: gray;
}
.color_cook {
  color: orange;
}
.color_ready {
  color: lightgreen;
}
.color_history {
  color: black;
}

.btn_barman {
  font-size: 50px;
  /* margin-top: 25px; */
  /* margin-left: 5px; */
  /* margin-right: 5px; */
  padding: 0px 15px;

  /* border: 5px solid #ff7d33; */
  border: 5px solid var(--bar-color-main);
  border-radius: 15px;
  max-width: max-content;
  /* width: 100%; */
  /* background-color: #fae5d3; */
  background-color: white;
  margin: 10px 10px;
}
.btn_barman:active {
  background-color: var(--bar-color-active);
}

.btn_del_order {
  color: #fe6060c9;
  border: 5px solid #fe6060c9
}
.del_ready {
  color: white;
  background-color: red;
}

.btn_close {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  margin-left: auto;
  /* position: relative; */
  width: 45px;
  height: 45px;
  border: 3px solid var(--bar-color-main);
  border-radius: 50%;
  background-color: white;
}
.btn_close:active {
  background-color: var(--bar-color-active);
}
</style>
